<template>
  <PageSection disable-sticky-margin :title="$t('attributes.reception_place')">
    <BaseSimpleRadioGroup
      name="reception"
      default-value="false"
      :isShowingKey="false"
      :isReturningKey="true"
      :options="yes_no_options"
      :disabled="permission"
      translationExtention="enums.yes_no"
      @change.self="getReceptionValue"
    />

    <div v-if="reception === 'true'" class="flex flex-col gap-4">
      <div
        v-if="settings.events.ask_nb_people_when_work_creating"
        class="max-w-xs"
      >
        <BaseInput
          :label="$t('attributes.nb_peoples')"
          :placeholder="$t('attributes.nb_peoples')"
          name="nb_peoples"
          type="number"
          parseType="int"
          :min="0"
          :max="999999"
          v-model="eventREC.nb_peoples"
          :disabled="permission"
        />
      </div>
      <SelectEventTimeslotModal
        v-if="
          metadata?.events?.formInputs?.display_timeslots?.visible.type?.includes(
            eventREC.type
          ) &&
          (eventREC.nb_peoples ||
            !settings.events.ask_nb_people_when_work_creating) &&
          auth_role !== 'customer-user'
        "
        :asset="eventREC.asset_id"
        :type="eventREC.type"
        :event-kind="eventREC.event_kind_id"
        :options="eventREC.timeslots"
        :index="work.events.indexOf(eventREC)"
        v-model="selectedEventTimeslot"
        @open="fetchTimeslots"
      />
    </div>
  </PageSection>
</template>

<script>
import SelectEventTimeslotModal from '@p/components/Event/SelectEventTimeslotModal.vue'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  name: 'SelectReceptionForm',
  components: { SelectEventTimeslotModal },
  data() {
    return {
      yes_no_options: { true: true, false: false },
      reception: null,
      selectedEventTimeslot: null
    }
  },
  computed: {
    ...mapGetters({
      work: 'work/getWork',
      metadata: 'work/getWorkMetadata',
      events: 'getEvents',
      auth: 'auth/getAuth',
      settings: 'settings/getSystemSettings'
    }),
    permission() {
      return !this.$can('manage_work')
    },
    eventREC() {
      return (
        this.work.events &&
        this.work.events.filter((event) => event.type === 'REC')[0]
      )
    },
    assetDisponibilities() {
      return (
        this.metadata.room_dispo &&
        this.metadata.room_dispo.filter(
          (dispo) =>
            dispo.asset.nb_places >= this.eventREC.nb_peoples &&
            dispo.asset.type === 'ROM'
        )
      )
    },
    auth_role() {
      return this.auth.roles[0]
    }
  },
  methods: {
    ...mapActions({
      fetchEventDisponbilitiesByOption: 'fetchEventDisponbilitiesByOption'
    }),
    ...mapMutations({
      alterWorkEventValuesByEventType: 'work/alterWorkEventValuesByEventType',
      removeEventFromWork: 'work/removeEventFromWork'
    }),
    getReceptionValue({ value }) {
      if (value === 'false') {
      }
      this.reception = value
    },
    getInputValue({ attribute, value }) {
      if (attribute === 'nb_peoples') {
      }
      this.alterWorkEventValuesByEventType({
        type: 'REC',
        attribute: attribute,
        value: value
      })
    },
    fetchTimeslots() {
      this.fetchEventDisponbilitiesByOption({
        params: {
          asset_id: this.eventREC.asset_id,
          type: this.eventREC.type,
          week_from: moment().locale('fr').week(),
          year: moment().format('YYYY'),
          event_kind_id: this.eventREC.event_kind_id
            ? this.eventREC.event_kind_id
            : null
        },
        index: this.work.events.indexOf(this.eventREC)
      })
    }
  },
  watch: {
    reception(newValue) {
      if (newValue === 'true') {
        this.alterWorkEventValuesByEventType({
          type: 'REC',
          attribute: 'type',
          value: 'REC'
        })
      } else {
        this.removeEventFromWork({ type: 'REC' })
      }
    },
    selectedEventTimeslot(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== null) {
        this.alterWorkEventValuesByEventType({
          type: 'REC',
          attribute: 'date_from',
          value: newValue.string_date
        })
        this.alterWorkEventValuesByEventType({
          type: 'REC',
          attribute: 'date_to',
          value: newValue.string_date
        })
        this.alterWorkEventValuesByEventType({
          type: 'REC',
          attribute: 'time_from',
          value: newValue.string_from
        })
        this.alterWorkEventValuesByEventType({
          type: 'REC',
          attribute: 'time_to',
          value: newValue.string_to
        })
        this.alterWorkEventValuesByEventType({
          type: 'REC',
          attribute: 'asset_id',
          value: newValue.asset.id
        })
      }
    }
  }
}
</script>

<style scoped></style>
